type ExternalServiceEnv = {
  VITE_GA_MEASUREMENT_ID?: string;
  VITE_GOOGLE_CLIENT_ID?: string;
};

export type ProductExternalServices = {
  gaMeasurementId: string | null;
  googleClientId: string | null;
};

function optionalValidatedValue(
  name: keyof ExternalServiceEnv,
  value: string | undefined,
  pattern: RegExp,
): string | null {
  const normalized = value?.trim();
  if (!normalized) return null;
  if (!pattern.test(normalized)) {
    throw new Error(`${name} is malformed`);
  }
  return normalized;
}

export function resolveProductExternalServices(env: ExternalServiceEnv): ProductExternalServices {
  return {
    gaMeasurementId: optionalValidatedValue(
      "VITE_GA_MEASUREMENT_ID",
      env.VITE_GA_MEASUREMENT_ID,
      /^G-[A-Z0-9]{4,20}$/,
    ),
    googleClientId: optionalValidatedValue(
      "VITE_GOOGLE_CLIENT_ID",
      env.VITE_GOOGLE_CLIENT_ID,
      /^[0-9]+-[a-z0-9_-]+\.apps\.googleusercontent\.com$/i,
    ),
  };
}

export const productExternalServices = resolveProductExternalServices({
  VITE_GA_MEASUREMENT_ID: import.meta.env.VITE_GA_MEASUREMENT_ID,
  VITE_GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID,
});
